import { useCallback } from 'react';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { useAppsFlyer } from '@ocx/cap-appsflyer';

import { useAlerts } from './useAlerts';
import { useIsOnline } from '../../hooks/useIsOnline';
import { useGetNavigationActions } from '../../hooks/useGetNavigationActions';
import { useRudderStack } from '../../lib/rudderStack/useRudderStack';

export interface IUseStartPayInsideParams {
  isEmailCompleted: boolean;
}

export const useStartPayInside = (params: IUseStartPayInsideParams) => {
  const { triggerEvent } = useRudderStack();
  const { logEvent: logAppsFlyerEvent } = useAppsFlyer();

  const alerts = useAlerts();
  const isOnline = useIsOnline();
  const { pushToPayInside } = useGetNavigationActions();
  const { isEmailCompleted } = params;

  return useCallback(async () => {
    triggerEvent('scan_for_pay_inside_clicked');

    if (!isOnline) {
      alerts.showNoConnectionAlert();
      return;
    }

    if (!isEmailCompleted) {
      alerts.showCompleteEmailAlert({
        onCompleted: () => {
          // It was decided to hardcode the event name for Gulf until AppsFlyer
          // will be used by other clients. It should be changed to more generic name later.
          logAppsFlyerEvent({
            eventName: 'gp_email_address_entered',
          });
          pushToPayInside();
        },
      });
      return;
    }

    pushToPayInside();
  }, [isEmailCompleted, isOnline, pushToPayInside, alerts, triggerEvent, logAppsFlyerEvent]);
};
